module.exports = __webpack_public_path__ + "static/media/SAINT_6620.b892a5c8.jpg";